import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 41 41"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsxs("linearGradient", {
                    x1: "83.8040865%",
                    y1: "50%",
                    x2: "-1.11022302e-14%",
                    y2: "50%",
                    id: "linearGradient-1",
                    children: [
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#50D0B7",
                            offset: "0%"
                        }),
                        /*#__PURE__*/ _jsx("stop", {
                            stopColor: "#00C3FF",
                            offset: "100%"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("g", {
                id: "页面-1",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ _jsx("g", {
                    id: "挖矿",
                    transform: "translate(-1664.000000, -28.000000)",
                    fill: "url(#linearGradient-1)",
                    fillRule: "nonzero",
                    children: /*#__PURE__*/ _jsx("g", {
                        id: "编组-17",
                        transform: "translate(187.000000, 0.000000)",
                        children: /*#__PURE__*/ _jsx("g", {
                            id: "编组-12",
                            transform: "translate(1423.000000, 25.000000)",
                            children: /*#__PURE__*/ _jsx("g", {
                                id: "swap_icon_yueliang",
                                transform: "translate(9.000000, 3.000000)",
                                children: /*#__PURE__*/ _jsx("path", {
                                    d: "M65.5,0 C76.8218379,0 86,9.17816207 86,20.5 C86,31.8218379 76.8218379,41 65.5,41 C54.1781621,41 45,31.8218379 45,20.5 C45,9.17816207 54.1781621,0 65.5,0 Z M65.2358469,8.83974945 C60.7750683,9.69998176 57.1145906,13.2644049 56.3622386,18.0145685 C55.402061,24.0768915 59.5386855,29.7704667 65.6010085,30.7306444 C70.3511721,31.4829964 74.8717093,29.1068078 77.0688757,25.1265164 C77.2907369,24.7220639 77.2604926,24.2250812 76.9890362,23.8514536 C76.7175799,23.477826 76.2542672,23.2954858 75.8010512,23.3815056 C74.8324921,23.5662485 73.817514,23.5933515 72.7839136,23.4296452 C68.0227542,22.6755517 64.7708671,18.2041772 65.5255411,13.4393526 C65.6892474,12.4057522 66.0255846,11.4445802 66.5036714,10.5847602 C66.7255326,10.1803078 66.6952883,9.68332501 66.4238319,9.3096974 C66.1523756,8.9360698 65.6890629,8.75372963 65.2358469,8.83974945 Z M63.408153,11.9580469 C63.3134486,12.3187666 63.2359095,12.6897195 63.1761161,13.0672402 C62.2159384,19.1295632 66.3531435,24.8194732 72.4118012,25.7790703 C72.789322,25.8388637 73.16608,25.8797503 73.5384102,25.9011497 C71.6291011,27.8267614 68.8509224,28.8332611 65.9700361,28.3769735 C61.2088768,27.62288 57.9606548,23.152086 58.7153289,18.3872614 C59.171036,15.5100404 60.9867785,13.178861 63.408153,11.9580469 Z"
                                })
                            })
                        })
                    })
                })
            })
        ]
    }));
};
export default Icon;
